import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface GDPRConsentStatus {
  gdpr_consent_given: boolean;
  gdpr_consent_date: string | null;
  gdpr_consent_version: string;
  gdpr_data_processing: boolean;
  gdpr_notifications: boolean;
  current_version: string;
  needs_consent: boolean;
}

@Injectable({ providedIn: "root" })
export class GDPRConsentService {
  private http = inject(HttpClient);
  private url = `${environment.apiUrl}/profile/gdpr-consent/`;

  getConsentStatus(): Observable<GDPRConsentStatus> {
    return this.http.get<GDPRConsentStatus>(this.url);
  }

  submitConsent(data: { gdpr_data_processing: boolean; gdpr_notifications: boolean }): Observable<GDPRConsentStatus> {
    return this.http.post<GDPRConsentStatus>(this.url, data);
  }
}
